export const receivePastedFiles = (event: ClipboardEvent) => {
  const clipboardData = event.clipboardData;
  if (!clipboardData) return;

  const files: File[] = [];
  const items = clipboardData.items;

  for (let i = 0; i < items.length; i++) {
    if (items[i].type.indexOf('image') !== -1) {
      const file = items[i].getAsFile();
      if (file) {
        files.push(file);
      }
    }
  }

  return files;
};
